const commonPurtrakList = {
  data() {
    return {
      _previousRoute: null,
      selected: []
    }
  },
  computed: {
    darkMode() {
      return this.$vuetify.theme.dark;
    },
    expansionPanelClass() {
      return this.darkMode ? 'grey darken-2' : 'blue-grey lighten-5';
    }
  },
  watch: {
    filters: {
      handler() {
        if (Object.entries(this.filters).some(e => this.$route.query[e[0]] != e[1])) {
          this.$router.replace({query: this.filters});
        }
      },
      immediate: false,
      deep: true
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm._previousRoute = from.name;
    })
  },

  async created() {
    if (!!this.filters)
      Object.entries(this.$route.query).forEach(q => this.filters[q[0]] = q[1] || this.filters[q[0]]);
  },
  methods: {
    includeColumn(column) {
      return true;
    }
  }
}

export default commonPurtrakList;